import React from 'react'
import MaterialTable from '@material-table/core'
import * as UIcons from '@iconscout/react-unicons'
import BranchHeader from './BranchHeader'
import { withTranslation } from 'react-i18next'
import BranchPreview from './BranchPreview'
import { getResponse, previewModal } from 'store/slices/miscSlice'
import dayjs from 'dayjs'
import TableActionBtn from 'components/TableActionBtn'
import { showModal } from 'store/slices/miscSlice'
import AddBranch from './AddBranch'
import { BranchValidation } from 'pages/Settings/validation'
// import Icons from 'includes/Icons'
import { useDispatch, useSelector } from 'react-redux'
import EmptyBranch from './EmptyBranch'
// import { apiRequest } from 'store/Misc/apiRequest'
// import { toast } from 'react-toastify'
// import { destructureErrorMessage } from 'Helper'
import useSWR, { mutate } from 'swr'
import { Box } from '@mui/material'
import usePermissions from 'hooks/usePermissions'
import Spinner from 'components/Spinner'
import { useEffect } from 'react'
import { useState } from 'react'

export default withTranslation()(function BranchesTable({ t }) {
  const { data } = useSWR('merchants/branches', { revalidateOnFocus: true })
  const dispatch = useDispatch()
  const [branches, setBranches] = useState([])
  const { isPermitted } = usePermissions()
  const { response } = useSelector(state => state?.misc)

  useEffect(() => {
    if (data) setBranches(prev => [...data.data.data])
  }, [data])
  useEffect(() => {
    mutate('merchants/branches')
  }, [response])

  return (
    <div className="w-full bg-white rounded-xl p-5">
      {
        (data) ? (
          !branches.length ? <EmptyBranch /> : <MaterialTable
            columns={[
              { title: t('settings.branch.table.header.name'), field: 'name' },
              { title: t('settings.branch.table.header.location'), field: 'location' },
              {
                title: t('settings.branch.table.header.url'), field: 'google_map_url',
                render: data => <Box component={'a'} href={data.location_url}
                  target={'_blank'} sx={{ cursor: 'pointer' }}>View Location</Box>
              },
            ]}
            options={{
              actionsColumnIndex: -1
            }}
            actions={[
              {
                tooltip: 'View details',
              },
            ]}
            localization={{
              header: {
                actions: ''
              }
            }}
            data={branches.sort((a, b) => b.id - a.id) ?? []}
            // icons={Icons}
            components={{
              Toolbar: props => (
                <div className='mb-4'>
                  <BranchHeader />
                </div>
              ),

              Action: ({ data }) => (
                <TableActionBtn
                  data={[
                    {
                      Content: {
                        icon: UIcons.UilEye,
                        text: t('misc.view_details')
                      },
                      action: () => {
                        dispatch(previewModal({
                          title: `${t('misc.branch_details')}`,
                          content: () => <BranchPreview tableProps={{
                            Name: data.name,
                            Location: data.location,
                            "Opens at": dayjs(Date.parse('16 Sep 2021 ' + data.opens_at)).format('h:mma'),
                            "Closes at": dayjs(Date.parse('16 Sep 2021 ' + data.closes_at)).format('h:mma'),
                            Description: data.description ?? t('misc.description_na'),
                            Code: data.code,
                            "Merchant ID": data.merchant_id,
                            status: <span className="text-green">{data.status}</span>
                          }}
                          />
                        }))
                      }
                    },
                    {
                      Content: {
                        icon: UIcons.UilEditAlt,
                        text: t('misc.edit_details')
                      },
                      disabled: !isPermitted?.edit_branches,
                      action: () => {
                        dispatch(
                          showModal(
                            {
                              title: t('settings.branch.edit'),
                              content: AddBranch,
                              dispacthAction: '',
                              url: `merchants/branches/${data.id}/active`,
                              action: (data) => console.log(data),
                              values: {
                                name: data.name,
                                location: data.location,
                                opens_at: data.opens_at,
                                closes_at: data.closes_at,
                                address: data.address
                              },
                              method: 'put',
                              validation: BranchValidation
                            }
                          )
                        );
                        dispatch(getResponse(`edit_branch_${data.id}`))
                      }
                    },
                    {
                      Content: {
                        icon: UIcons.UilTrash,
                        text: t('misc.delete'),
                        classList: 'text-failure'
                      },
                      disabled: !isPermitted?.delete_branches,
                      action: () => {
                        dispatch(
                          showModal(
                            {
                              title: t('settings.branch.delete'),
                              content: () => <div className="text-md w-full text-center">
                                {t('misc.confirm_action.1')}
                                <span className="text-red-400 font-medium">{(t('misc.delete')).toLowerCase()}</span>
                                {t('misc.confirm_action.2')}
                              </div>,
                              url: `merchants/branches/${data.id}`,
                              action: (data) => console.log(data, 'll'),
                              method: 'delete',
                              btnText: t('misc.continue'),
                              disableBtn: false,
                              successMsg: t('settings.branch.form.delete_success'),
                            }
                          )
                        );
                        dispatch(getResponse(`delete_branch_${data.id}`))
                      }
                    }
                  ]}
                />
              ),
            }}
          />
        ) : (
          <Spinner />
        )
      }
    </div>
  )
})
